import * as React from 'react';

import { PhoneButtonMobile } from '../../components/PhoneButton';
import { usePhoneButton } from './hooks/usePhoneButton';

export const PhoneButtonMobileContainer: React.FC = () => {
  const { handlePhoneCall, phone } = usePhoneButton();

  if (!phone) {
    return null;
  }

  return <PhoneButtonMobile phone={phone} onClick={handlePhoneCall} />;
};
